import {root} from '../config'

export const loginRoot = root + '/login';
export const personal_root = root + '/personal';

